import { Component, Inject, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfigOptions } from '@multimediasrl/emed-ui-config';
import { CustomTheme, IMyCssService, SharedCssService } from '@multimediasrl/emed-ui-shared';

import { Store } from '@ngxs/store';

import { TranslateService } from '@ngx-translate/core';

import { OidcSecurityService } from 'angular-auth-oidc-client';

import { PrimeNG } from 'primeng/config';

import { lastValueFrom, Subscription } from 'rxjs';

import { environment } from '../environments/environment';

import { CognitoAccessToken, CognitoAuthenticated, CognitoIdToken } from './modules/dispatcher/state/action/cognito.action';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private subArray: Subscription[] = [];

  title = 'emed-dispatcher-ui';

  private sharedCssService: SharedCssService;

  private readonly oidcSecurityService = inject(OidcSecurityService);

  constructor(
    protected translate: TranslateService,
    private config: PrimeNG,
    protected configOptions: ConfigOptions,
    private store: Store,
    private router: Router,
    @Inject('IMyCssService') iMyCssService: IMyCssService
  ) {
    console.log('Config ricevuta:', environment);

    this.sharedCssService = iMyCssService as unknown as SharedCssService;

    const body = document.querySelector('body');
    const html = document.querySelector('html');

    setTimeout(() => {
      if (localStorage.getItem(environment.localStorageID + '-app-theme') == CustomTheme.DARK) {
        body.className = 'theme-dark';
        html.className = 'my-app-dark';
        this.sharedCssService.setCssStyle('theme-dark');
      } else {
        body.className = 'theme-light';
        this.sharedCssService.setCssStyle('theme-light');
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.subArray.forEach((x) => x.unsubscribe());
  }

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, accessToken, idToken }) => {
      this.store.dispatch(new CognitoAuthenticated(isAuthenticated));
      this.store.dispatch(new CognitoIdToken(idToken));
      this.store.dispatch(new CognitoAccessToken(accessToken));

      // Reindirizza alla pagina pubblica se non autenticato
      if (!isAuthenticated) {
        this.router.navigate([environment.baseUrl + '/public']);
      }
    });

    this.setPrimeLocales();

    this.setHtmlSize();
  }

  async setPrimeLocales(): Promise<void> {
    let localStorageSiglaTraduzione = localStorage.getItem(environment.localStorageID + '-siglaTraduzione');

    if (localStorageSiglaTraduzione == null || localStorageSiglaTraduzione === '') {
      localStorageSiglaTraduzione = 'it';
      localStorage.setItem(environment.localStorageID + '-siglaTraduzione', localStorageSiglaTraduzione);
    }

    this.translate.setDefaultLang('it');
    await lastValueFrom(this.translate.use(localStorageSiglaTraduzione));

    // PrimeNG cambio lingua (iniziale)
    this.config.setTranslation(await lastValueFrom(this.translate.get('primeng')));

    // PrimeNG cambio lingua (futuri)
    this.subArray.push(
      this.translate.onLangChange.subscribe((x) => {
        this.translate.get('primeng').subscribe((res) => {
          this.config.setTranslation(res);
        });
      })
    );
  }

  setHtmlSize(): void {
    const els = document.getElementsByTagName('html');

    if (els.length == 0) {
      return;
    }

    let el = els[0];

    let settedHtmlSize = localStorage.getItem(environment.localStorageID + '-htmlSize');

    if (isNaN(parseInt(settedHtmlSize)) && parseInt(settedHtmlSize) < 6) {
      return;
    }

    if (settedHtmlSize != null) {
      // ParseInt e sovrascrittura DOM html
      el.style.fontSize = parseInt(settedHtmlSize) + 'px';

      return;
    }

    el.style.fontSize = '14px';

    // Scrittura nel localStorage
    localStorage.setItem(environment.localStorageID + '-htmlSize', '14');
  }
}
